import { section } from "@/glow";
import { qs, qsa, listen, add, remove, contains } from "@fluorescent/dom";
import { animateTabbedCollections, shouldAnimate } from "@/lib/animation";
import ProductItem from "@/lib/product-item";

const selectors = {
  navItems: "[data-tab-button]",
  sliderContainer: ".featured-collection-slider-grid",
};

const classes = {
  selected: "selected",
  active: "active",
  fadeout: "fadeout",
  initReveal: "init-reveal",
  reveal: "reveal",
};

section("tabbed-collections", {
  onLoad() {
    this.events = [];
    this.productItem = ProductItem(this.container);
    this.sliderElements = qsa(selectors.sliderContainer, this.container);
    this.navItems = qsa(selectors.navItems, this.container);

    this.navItems.forEach(button =>
      this.events.push(
        listen(button, "click", this._handleNavButton.bind(this))
      )
    );

    if (shouldAnimate(this.container)) {
      this.animateTabbedCollections = animateTabbedCollections(this.container);
    }
  },

  _handleNavButton(e) {
    e.preventDefault();
    const { navigationItem } = e.currentTarget.dataset;

    if (!contains(e.currentTarget, classes.selected)) {
      this._hideAll();
      this._show(parseInt(navigationItem, 10));
    }
  },

  _hideAll() {
    remove(this.navItems, classes.selected);
    remove(this.sliderElements, classes.active);
  },

  _show(index) {
    const collection = qs(`[data-collection="${index}"]`, this.container);

    if (this.navItems.length) {
      const navigationItem = qs(
        `[data-navigation-item="${index}"]`,
        this.container
      );
      add(navigationItem, classes.selected);
    }
    
    add(collection, classes.active);
  },

  onUnload() {
    this.productItem && this.productItem.unload();
    this.animateTabbedCollections?.destroy();
    this.events.forEach(unsubscribe => unsubscribe());
  },

  onBlockSelect({ target }) {
    const { collection } = target.dataset;
    this._hideAll();
    this._show(parseInt(collection, 10));
  },
});
